// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableTCU_card__retp3 {
    border-radius: 12px;
     /* position: relative; */
     z-index: 1;
}

.TableTCU_tableWrapper__pXpMO {
    width: 100%;
    overflow-x: auto;
    border-radius: 8px;
    /* no max-height: expanded depot rows grow the card instead of
       scrolling inside it, so the full table fits in one screenshot */
    min-height: 200px;
    overflow-y: visible;
}

.TableTCU_mainTable__tgwF4 {
    width: 100%;
    min-width: 1000px;
    margin-bottom: 0;
    border-collapse: separate;
    border-spacing: 0;
}

/* =========================================
   HEADER
========================================= */

.TableTCU_mainTable__tgwF4 thead th {
    background-color: var(--primary-blue-theme-color);
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    padding: 4px 8px;
    position: sticky;
    z-index: 2;
}

.TableTCU_mainTable__tgwF4 thead tr:first-child th {
    top: 0;
    z-index: 3;
}

.TableTCU_mainTable__tgwF4 thead tr:nth-child(2) th {
    top: 18px;
    z-index: 2;
}

/* =========================================
   MAIN TABLE VALUES
========================================= */

.TableTCU_mainTable__tgwF4 tbody td {
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    padding: 6px 8px;
}

/* =========================================
   CITY
========================================= */

.TableTCU_cityRow__9mH8u {
    transition:
        background-color 0.2s ease,
        box-shadow 0.2s ease;
}

.TableTCU_cityRow__9mH8u td {
    background-color: #ffffff;
}

.TableTCU_cityRow__9mH8u:hover td {
    background-color: #f8fbff;
}

.TableTCU_cityRowActive__r\\+GAG td {
    background-color: #edf5fc !important;
}

/* City cell */

.TableTCU_cityCell__WcOpH {
    cursor: pointer;
    font-weight: 700;
    text-align: left !important;
    white-space: nowrap;
}

.TableTCU_cityCell__WcOpH:hover {
    background-color: transparent !important;
}

.TableTCU_cityContent__RX2fU {
    display: flex;
    align-items: center;
    gap: 6px;
}

.TableTCU_accordionIcon__ZUL05 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    font-size: 9px;
    color: var(--primary-blue-theme-color);
    transition: transform 0.2s ease;
}

.TableTCU_cityName__L8HA5 {
    color: #26384a;
    font-size: 12px;
    font-weight: 700;
}

/* =========================================
   DEPOT
========================================= */

.TableTCU_depotRow__Vox0k {
    background-color: #fafbfc;
    animation: TableTCU_depotSlideIn__DS8Od 0.2s ease-out;
}

.TableTCU_depotRow__Vox0k td {
    background-color: #fafbfc !important;
    color: #6c757d;
    font-size: 11px !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    border-top: 0 !important;
}

.TableTCU_depotRow__Vox0k:hover td {
    background-color: #f4f6f8 !important;
}

.TableTCU_depotName__3XTnt {
    position: relative;
    text-align: left !important;
    padding-left: 38px !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #697681 !important;
    white-space: nowrap;
}

/* Existing depot indicator */

.TableTCU_depotIndicator__wJl4f {
    position: absolute;
    left: 24px;
    top: 50%;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #aeb8c1;
    transform: translateY(-50%);
    transition:
        transform 0.15s ease,
        background-color 0.15s ease;
}

.TableTCU_depotRow__Vox0k:hover .TableTCU_depotIndicator__wJl4f {
    transform: translateY(-50%) scale(1.15);
    background-color: #7f8b95;
}

/* =========================================
   DEPOT ANIMATION
========================================= */

@keyframes TableTCU_depotSlideIn__DS8Od {
    from {
        opacity: 0;
        transform: translateY(-3px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* =========================================
   COUNT BADGE
========================================= */

.TableTCU_countBadge__DOUlF {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    min-width: 24px;
    min-height: 24px;

    padding: 0;

    border-radius: 50%;

    background-color: #fff1f2;

    font-size: 11px;
    font-weight: 600;

    cursor: pointer;

    transition:
        transform 0.15s ease,
        background-color 0.15s ease,
        color 0.15s ease,
        box-shadow 0.15s ease;
}

.TableTCU_countBadge__DOUlF:hover {
    transform: scale(1.08);
}

.TableTCU_greenBadge__ttByO {
    border: 1px solid #09a529;
    color: #09a529;
    background-color: #f1fff4;
}

.TableTCU_redBadge__VhTUJ {
    border: 1px solid #dc3545;
    color: #dc3545;
    background-color: #fff1f2;
}

.TableTCU_zeroValue__5NcEc {
    color: #6c757d;
}

/* =========================================
   CLICKABLE
========================================= */

.TableTCU_clickable__Y7u5V {
    cursor: pointer;
}

.TableTCU_clickable__Y7u5V:hover {
    background-color: transparent !important;
}

.TableTCU_mainTable__tgwF4 td:focus {
    outline: none;
}

.TableTCU_mainTable__tgwF4 td:focus-visible .TableTCU_countBadge__DOUlF {
    outline: 2px solid var(--primary-blue-theme-color);
    outline-offset: 2px;
}

/* =========================================
   SCOPE BADGE
========================================= */

.TableTCU_scopeBadge__SkTnu {
    background-color: #f8f9fa;
    color: #6c757d;
    border: 1px solid #dee2e6;
    font-weight: 400;
    padding: 6px 14px 6px 5px;
}

/* =========================================
   HINT
========================================= */

.TableTCU_hint__fKkAB {
    color: #6c757d;
}

/* =========================================
   DETAIL
========================================= */

.TableTCU_detailPanel__WvNK3 {
    border-color: #dee2e6 !important;
}

.TableTCU_detailTable__DNfRD {
    font-size: 12px;
}

.TableTCU_detailTable__DNfRD thead th {
    text-align: center;
    vertical-align: middle;
}

.TableTCU_detailTable__DNfRD tbody td {
    text-align: center;
    vertical-align: middle;
}

/* =========================================
   STATUS
========================================= */

.TableTCU_statusBadge__57ku2 {
    background-color: #fff1f2;
    color: #dc3545;
    border: 1px solid #dc3545;
    font-weight: 500;
    padding: 4px 8px;
}

/* =========================================
   EMPTY
========================================= */

.TableTCU_emptyState__zhllr {
    text-align: center !important;
    color: #6c757d;
    padding: 12px !important;
}

/* =========================================
   LOADING
========================================= */

.TableTCU_loadingState__7LdCA {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 18px;
}

/* =========================================
   MOBILE
========================================= */

@media (max-width: 768px) {
    .TableTCU_tableWrapper__pXpMO {
        min-height: 250px;
    }

    .TableTCU_mainTable__tgwF4 {
        min-width: 900px;
    }

    .TableTCU_mainTable__tgwF4 thead th {
        font-size: 11px;
        padding: 4px 6px;
    }

    .TableTCU_mainTable__tgwF4 tbody td {
        font-size: 11px;
        padding: 5px 6px;
    }

    .TableTCU_cityName__L8HA5 {
        font-size: 11px;
    }

    .TableTCU_depotName__3XTnt {
        padding-left: 34px !important;
    }

    .TableTCU_depotIndicator__wJl4f {
        left: 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/LostTCUTable/TableTCU.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;KAClB,wBAAwB;KACxB,UAAU;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB;sEACkE;IAClE,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;;2CAE2C;;AAE3C;IACI,iDAAiD;IACjD,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,MAAM;IACN,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;;2CAE2C;;AAE3C;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI;;4BAEwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA,cAAc;;AAEd;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,sCAAsC;IACtC,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,yBAAyB;IACzB,qDAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,6BAA6B;;AAE7B;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B;;mCAE+B;AACnC;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;AAC7B;;AAEA;;2CAE2C;;AAE3C;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;2CAE2C;;AAE3C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;;IAEvB,eAAe;IACf,gBAAgB;;IAEhB,UAAU;;IAEV,kBAAkB;;IAElB,yBAAyB;;IAEzB,eAAe;IACf,gBAAgB;;IAEhB,eAAe;;IAEf;;;;6BAIyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;;2CAE2C;;AAE3C;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;2CAE2C;;AAE3C;IACI,cAAc;AAClB;;AAEA;;2CAE2C;;AAE3C;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;2CAE2C;;AAE3C;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,6BAA6B;IAC7B,cAAc;IACd,wBAAwB;AAC5B;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,aAAa;AACjB;;AAEA;;2CAE2C;;AAE3C;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".card {\n    border-radius: 12px;\n     /* position: relative; */\n     z-index: 1;\n}\n\n.tableWrapper {\n    width: 100%;\n    overflow-x: auto;\n    border-radius: 8px;\n    /* no max-height: expanded depot rows grow the card instead of\n       scrolling inside it, so the full table fits in one screenshot */\n    min-height: 200px;\n    overflow-y: visible;\n}\n\n.mainTable {\n    width: 100%;\n    min-width: 1000px;\n    margin-bottom: 0;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n/* =========================================\n   HEADER\n========================================= */\n\n.mainTable thead th {\n    background-color: var(--primary-blue-theme-color);\n    color: #ffffff;\n    font-size: 12px;\n    font-weight: 600;\n    text-align: center;\n    vertical-align: middle;\n    white-space: nowrap;\n    padding: 4px 8px;\n    position: sticky;\n    z-index: 2;\n}\n\n.mainTable thead tr:first-child th {\n    top: 0;\n    z-index: 3;\n}\n\n.mainTable thead tr:nth-child(2) th {\n    top: 18px;\n    z-index: 2;\n}\n\n/* =========================================\n   MAIN TABLE VALUES\n========================================= */\n\n.mainTable tbody td {\n    font-size: 12px;\n    text-align: center;\n    vertical-align: middle;\n    padding: 6px 8px;\n}\n\n/* =========================================\n   CITY\n========================================= */\n\n.cityRow {\n    transition:\n        background-color 0.2s ease,\n        box-shadow 0.2s ease;\n}\n\n.cityRow td {\n    background-color: #ffffff;\n}\n\n.cityRow:hover td {\n    background-color: #f8fbff;\n}\n\n.cityRowActive td {\n    background-color: #edf5fc !important;\n}\n\n/* City cell */\n\n.cityCell {\n    cursor: pointer;\n    font-weight: 700;\n    text-align: left !important;\n    white-space: nowrap;\n}\n\n.cityCell:hover {\n    background-color: transparent !important;\n}\n\n.cityContent {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.accordionIcon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 12px;\n    font-size: 9px;\n    color: var(--primary-blue-theme-color);\n    transition: transform 0.2s ease;\n}\n\n.cityName {\n    color: #26384a;\n    font-size: 12px;\n    font-weight: 700;\n}\n\n/* =========================================\n   DEPOT\n========================================= */\n\n.depotRow {\n    background-color: #fafbfc;\n    animation: depotSlideIn 0.2s ease-out;\n}\n\n.depotRow td {\n    background-color: #fafbfc !important;\n    color: #6c757d;\n    font-size: 11px !important;\n    padding-top: 5px !important;\n    padding-bottom: 5px !important;\n    border-top: 0 !important;\n}\n\n.depotRow:hover td {\n    background-color: #f4f6f8 !important;\n}\n\n.depotName {\n    position: relative;\n    text-align: left !important;\n    padding-left: 38px !important;\n    font-size: 11px !important;\n    font-weight: 500 !important;\n    color: #697681 !important;\n    white-space: nowrap;\n}\n\n/* Existing depot indicator */\n\n.depotIndicator {\n    position: absolute;\n    left: 24px;\n    top: 50%;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: #aeb8c1;\n    transform: translateY(-50%);\n    transition:\n        transform 0.15s ease,\n        background-color 0.15s ease;\n}\n\n.depotRow:hover .depotIndicator {\n    transform: translateY(-50%) scale(1.15);\n    background-color: #7f8b95;\n}\n\n/* =========================================\n   DEPOT ANIMATION\n========================================= */\n\n@keyframes depotSlideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-3px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* =========================================\n   COUNT BADGE\n========================================= */\n\n.countBadge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    min-width: 24px;\n    min-height: 24px;\n\n    padding: 0;\n\n    border-radius: 50%;\n\n    background-color: #fff1f2;\n\n    font-size: 11px;\n    font-weight: 600;\n\n    cursor: pointer;\n\n    transition:\n        transform 0.15s ease,\n        background-color 0.15s ease,\n        color 0.15s ease,\n        box-shadow 0.15s ease;\n}\n\n.countBadge:hover {\n    transform: scale(1.08);\n}\n\n.greenBadge {\n    border: 1px solid #09a529;\n    color: #09a529;\n    background-color: #f1fff4;\n}\n\n.redBadge {\n    border: 1px solid #dc3545;\n    color: #dc3545;\n    background-color: #fff1f2;\n}\n\n.zeroValue {\n    color: #6c757d;\n}\n\n/* =========================================\n   CLICKABLE\n========================================= */\n\n.clickable {\n    cursor: pointer;\n}\n\n.clickable:hover {\n    background-color: transparent !important;\n}\n\n.mainTable td:focus {\n    outline: none;\n}\n\n.mainTable td:focus-visible .countBadge {\n    outline: 2px solid var(--primary-blue-theme-color);\n    outline-offset: 2px;\n}\n\n/* =========================================\n   SCOPE BADGE\n========================================= */\n\n.scopeBadge {\n    background-color: #f8f9fa;\n    color: #6c757d;\n    border: 1px solid #dee2e6;\n    font-weight: 400;\n    padding: 6px 14px 6px 5px;\n}\n\n/* =========================================\n   HINT\n========================================= */\n\n.hint {\n    color: #6c757d;\n}\n\n/* =========================================\n   DETAIL\n========================================= */\n\n.detailPanel {\n    border-color: #dee2e6 !important;\n}\n\n.detailTable {\n    font-size: 12px;\n}\n\n.detailTable thead th {\n    text-align: center;\n    vertical-align: middle;\n}\n\n.detailTable tbody td {\n    text-align: center;\n    vertical-align: middle;\n}\n\n/* =========================================\n   STATUS\n========================================= */\n\n.statusBadge {\n    background-color: #fff1f2;\n    color: #dc3545;\n    border: 1px solid #dc3545;\n    font-weight: 500;\n    padding: 4px 8px;\n}\n\n/* =========================================\n   EMPTY\n========================================= */\n\n.emptyState {\n    text-align: center !important;\n    color: #6c757d;\n    padding: 12px !important;\n}\n\n/* =========================================\n   LOADING\n========================================= */\n\n.loadingState {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 18px;\n}\n\n/* =========================================\n   MOBILE\n========================================= */\n\n@media (max-width: 768px) {\n    .tableWrapper {\n        min-height: 250px;\n    }\n\n    .mainTable {\n        min-width: 900px;\n    }\n\n    .mainTable thead th {\n        font-size: 11px;\n        padding: 4px 6px;\n    }\n\n    .mainTable tbody td {\n        font-size: 11px;\n        padding: 5px 6px;\n    }\n\n    .cityName {\n        font-size: 11px;\n    }\n\n    .depotName {\n        padding-left: 34px !important;\n    }\n\n    .depotIndicator {\n        left: 22px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `TableTCU_card__retp3`,
	"tableWrapper": `TableTCU_tableWrapper__pXpMO`,
	"mainTable": `TableTCU_mainTable__tgwF4`,
	"cityRow": `TableTCU_cityRow__9mH8u`,
	"cityRowActive": `TableTCU_cityRowActive__r+GAG`,
	"cityCell": `TableTCU_cityCell__WcOpH`,
	"cityContent": `TableTCU_cityContent__RX2fU`,
	"accordionIcon": `TableTCU_accordionIcon__ZUL05`,
	"cityName": `TableTCU_cityName__L8HA5`,
	"depotRow": `TableTCU_depotRow__Vox0k`,
	"depotSlideIn": `TableTCU_depotSlideIn__DS8Od`,
	"depotName": `TableTCU_depotName__3XTnt`,
	"depotIndicator": `TableTCU_depotIndicator__wJl4f`,
	"countBadge": `TableTCU_countBadge__DOUlF`,
	"greenBadge": `TableTCU_greenBadge__ttByO`,
	"redBadge": `TableTCU_redBadge__VhTUJ`,
	"zeroValue": `TableTCU_zeroValue__5NcEc`,
	"clickable": `TableTCU_clickable__Y7u5V`,
	"scopeBadge": `TableTCU_scopeBadge__SkTnu`,
	"hint": `TableTCU_hint__fKkAB`,
	"detailPanel": `TableTCU_detailPanel__WvNK3`,
	"detailTable": `TableTCU_detailTable__DNfRD`,
	"statusBadge": `TableTCU_statusBadge__57ku2`,
	"emptyState": `TableTCU_emptyState__zhllr`,
	"loadingState": `TableTCU_loadingState__7LdCA`
};
export default ___CSS_LOADER_EXPORT___;
